
<div [matTooltip]="label + ': ' + value + ' (click to copy)'" matTooltipPosition="below" class="copiable-info"  (click)="copyToClipboard()">
  <mat-icon inline>{{icon}}</mat-icon>
  <span>{{(value ?? '').slice(0,
    15)}}{{ ((value ?? '').length > 15) ? '...' : ''}}</span>
</div>